export default __webpack_public_path__ + "static/media/1_0146.23bfb2c8.webp";